"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M22 2H2v20l4-4h9v-8h7z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
}, "1")], 'QuickreplySharp');